import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { WarningIcon as Warning, PawPrintIcon as PawPrint } from "@phosphor-icons/react";

/** Pinned safety flags from the dog's Care Passport on the walker's
 * live-walk screen — triggers, gear, and pace at a glance. */
export default function PassportSafetyFlags({ dogId }) {
  const [p, setP] = useState(null);

  useEffect(() => {
    if (dogId) api.get(`/passports/${dogId}`).then((r) => setP(r.data)).catch(() => setP(null));
  }, [dogId]);

  if (!p) return null;
  const w = p.walking || {};
  const items = [];
  if (w.triggers?.length) items.push({ warn: true, text: `Reactive to: ${w.triggers.join(", ")}` });
  if (w.leash_behavior && w.leash_behavior !== "Loose leash") items.push({ warn: false, text: `Leash: ${w.leash_behavior}` });
  if (w.equipment) items.push({ warn: false, text: `Gear: ${w.equipment}` });
  if (w.pace) items.push({ warn: false, text: `Pace: ${w.pace}` });
  if (w.recall_ok === false) items.push({ warn: true, text: "Never off leash" });
  if (!items.length) return null;

  return (
    <div className="rounded-lg border border-gold/40 bg-cream/70 p-3 mb-4" data-testid="walk-safety-flags">
      <p className="text-[10px] uppercase tracking-wider font-bold text-gold mb-1.5 flex items-center gap-1">
        <PawPrint size={11} weight="duotone" /> {p.dog?.name} — from the Care Passport
      </p>
      <div className="flex flex-wrap gap-1.5">
        {items.map((it) => (
          <span key={it.text}
            className={`text-[11.5px] font-semibold rounded-full px-2.5 py-1 inline-flex items-center gap-1 ${
              it.warn ? "bg-[#C1272D]/10 text-[#8f1d22] border border-[#C1272D]/30" : "bg-white text-ink border border-[#E5E5E5]"}`}>
            {it.warn && <Warning size={11} weight="fill" />}
            {it.text}
          </span>
        ))}
      </div>
    </div>
  );
}
